import { render, staticRenderFns } from "./Droppable.vue?vue&type=template&id=2934d293&scoped=true"
import script from "./Droppable.vue?vue&type=script&lang=js"
export * from "./Droppable.vue?vue&type=script&lang=js"
import style0 from "./Droppable.vue?vue&type=style&index=0&id=2934d293&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2934d293",
  null
  
)

export default component.exports